"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgGoogle = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.09 11.778c0-.635.109-1.244.3-1.815L3.026 7.446A9.607 9.607 0 0 0 2 11.778c0 1.557.37 3.025 1.024 4.328l3.364-2.521a5.675 5.675 0 0 1-.297-1.807", fill: "#FBBC05" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6c1.409 0 2.682.489 3.682 1.289l2.909-2.845C16.818 2.934 14.545 2 12 2 8.048 2 4.652 4.213 3.025 7.446l3.366 2.517C7.166 7.658 9.377 6 12 6", fill: "#EA4335" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 17.556c-2.623 0-4.834-1.658-5.61-3.963l-3.365 2.516c1.627 3.234 5.023 5.447 8.975 5.447 2.439 0 4.768-.848 6.515-2.437L15.321 16.7c-.902.555-2.037.855-3.321.855", fill: "#34A853" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.546 11.778c0-.578-.091-1.2-.228-1.778H12v3.778h5.364A4.404 4.404 0 0 1 15.32 16.7l3.194 2.419c1.836-1.669 3.03-4.154 3.03-7.341", fill: "#4285F4" })));
};
exports.default = factorySvgIcon_1.default(SvgGoogle);
//# sourceMappingURL=SvgGoogle.js.map